<!--
  O mesmo que temos hoje
  Conteúdo será revisado posteriormente
  Tirar última frase em negrito da página de educ. infantil
-->
<template>
  <section v-if="segmento">
    <Banner value="Ensino Fundamental I" />
    <!-- <Ead ciclo="2" /> -->
    <hr style="border:5px solid #DDD" />

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex xs12>
            <p class="lead">{{ segmento.description }}</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none;">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <v-flex lg8>
            <div v-for="info in segmento.infos" :key="info.id">
              <h3>{{ info.title }}</h3>
              <p>{{ info.description }}</p>
            </div>
          </v-flex>
          <v-flex lg4>
            <Lateral :segmento="2" />
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import Lateral from "../../components/segmento/Lateral";

import jsonData from '../../../public/api/v1/segmento/2.json'

export default {
  data: () => ({
    segmento: null
  }),
  created: function() {
    this.segmento = jsonData;
  },
  components: {
    Banner,
    Lateral
  }
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}

ul,
ol {
  margin-bottom: 20px;
}

table {
  width: 100%;
  tr {
    &:first-child {
      td {
        color: white;
        font-weight: bold;
        background: #666;
        border: 1px solid #666;
      }
    }
    td {
      text-align: center;
      background: #fff;
      border: 1px solid #ddd;
      padding: 5px;
    }
  }
}

.img3d {
  width: 100%;
  transform: perspective(400px) rotateY(15deg);
  box-shadow: -5px 0px 10px #666;
}
</style>
